import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalConstants } from "../common/global-constants";
import { BOToothType } from "../models/odo/BOToothType.model";
import { BOToothStateCategory } from "../models/BOToothStateCategory.model";

@Injectable({
  providedIn: 'root'
})
export class ToothStateCategoryService{
    myAppUrl = GlobalConstants.apiURL;
    myApiUrl = 'api/ToothStateCategory';

    constructor(private http:HttpClient){}

    getAll():Observable<BOToothStateCategory[]>{
        return this.http.get<BOToothStateCategory[]>(this.myAppUrl + this.myApiUrl);
    }
}
